import React from "react";
import { useTranslation } from "react-i18next";

export interface BasicSummaryProps {
  dob?: string;
}

export const BasicSummary: React.FC<BasicSummaryProps> = ({ dob }) => {
  const { t } = useTranslation();
  if (!dob) return null;
  return (
    <p>
      <strong>{t("basicSummary.dobLabel")}:</strong> {dob}
    </p>
  );
};
